import { render, staticRenderFns } from "./DeliveryNotes.vue?vue&type=template&id=5aeaeaa3&scoped=true"
import script from "./DeliveryNotes.vue?vue&type=script&lang=js"
export * from "./DeliveryNotes.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNotes.vue?vue&type=style&index=0&id=5aeaeaa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeaeaa3",
  null
  
)

export default component.exports